import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { useAppSelector } from "../../app/store/configureStore";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  firstTextBox: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const PositiveSelf: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const isHomeVisitor = user?.credentialTypeId === 4;
  const firstSystemCodeId = isHomeVisitor ? 174 : 175;

  const defaultValues = {
    firstTextBox: answersData.find(
      (answer) => answer.systemCodeId === firstSystemCodeId
    )?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderSelfConceptSocialEmotionalSkills = () => {
    return (
      <ul>
        <li>
          What strategies have you implemented to support families in providing
          basic physical care (feeding, bathing, dressing, diapering) respecting
          the temp and sensitivities of their child?
        </li>
        <li>
          How do you ensure that spaces within the environment provide a sense
          of self-identity/worth for all children?
        </li>
        <li>
          How have you engaged with families and helped them value their own
          self-worth and appreciate each child and adult family member as
          individuals?
        </li>
        <li>
          What resources and materials have you implemented to help parents
          achieve goals they have set for themselves, their families, and
          children?
        </li>
        <li>
          How do you demonstrate sensitivity to differing cultural values and
          expectations concerning independence, autonomy, and expression of
          feelings?
        </li>
        <li>
          What steps can you take to support communication between families with
          children who are dual language learners?
        </li>
        <li>
          What activities can you help families implement to promote early
          literacy skills?
        </li>
      </ul>
    );
  };

  return (
    <>
      <Grid container bgcolor={"#FFF4F0"} pb={3}>
        <Grid item xs={12} px={3} pt={3}>
          <Typography variant="body1" fontWeight={"bold"} paragraph>
            CS III-a &ndash; Supporting Positive Self-Concept and
            Social-Emotional Skills
          </Typography>
          <Typography variant="body1" paragraph>
            {user?.credentialTypeId === 4
              ? "How do you help families promote their children's development of positive self-concept and growing social-emotional skills in children?"
              : "What are some of the ways you support the development of positive self-concepts and growing social-emotional skills in children?"}
          </Typography>
          <ReadMoreReadLess>
            {renderSelfConceptSocialEmotionalSkills()}
          </ReadMoreReadLess>
        </Grid>
        <Grid item xs={12} px={3} pt={3}>
          <TextField
            label={
              user?.credentialTypeId !== 4
                ? "I support the development of positive self-concept and social-emotional skills in children by"
                : "I help families promote their children’s development of positive self-concept and social-emotional skills by"
            }
            multiline
            rows={2}
            fullWidth
            {...register("firstTextBox")}
            name="firstTextBox"
            sx={{ bgcolor: "white" }}
            value={
              answersData.find(
                (answer) => answer.systemCodeId === firstSystemCodeId
              )?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;
              const systemCodeId = firstSystemCodeId;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.firstTextBox?.message}
            helperText={errors.firstTextBox?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.firstTextBox?.length}/500
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
export default PositiveSelf;
